var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apr-alert__title"},[_c('i',{staticClass:"apr-icon-alert",attrs:{"aria-hidden":"true"}}),_vm._v("\n  "+_vm._s(this.name)+" is Sold Out for "+_vm._s(this.checkinDate)+" - "+_vm._s(this.checkoutDate)+".\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }